import baseService from '../shared/baseService';

const clientIrsConversionRateService = (clientId: number) =>
    baseService(`clients/${clientId}/irs-conversion-rates`);

export default { 
    clientIrsConversionRateService
};

